import React, { useState } from 'react';

import { useIsIntegrationAdmin } from 'app/developer-v3/hooks';

import TableBody from './TableBody';
import {
  IntegrationType,
  onDeleteCallback,
  onViewCallback,
  onEditCallback,
} from '../types';

type Props = {
  integration: IntegrationType;
  onDelete: onDeleteCallback;
  onEdit: onEditCallback;
  onView: onViewCallback;
};

function Container(props: Props) {
  const { integration, onDelete, onEdit, onView } = props;

  const [
    isLoadingActionItemsEnabled,
    setIsLoadingActionItemsEnabled,
  ] = useState(false);

  const {
    isAdmin: isIntegrationAdmin,
    isLoading: isLoadingIsIntegrationAdmin,
    error: errorIsIntegrationAdmin,
  } = useIsIntegrationAdmin(
    { integrationId: integration.id },
    { enabled: isLoadingActionItemsEnabled }
  );

  const onClickToggle = () => {
    setIsLoadingActionItemsEnabled(true);
  };

  return (
    <TableBody
      integration={integration}
      isIntegrationAdmin={isIntegrationAdmin && !errorIsIntegrationAdmin}
      isLoadingActions={isLoadingIsIntegrationAdmin}
      onClickToggle={onClickToggle}
      onDelete={onDelete}
      onEdit={onEdit}
      onView={onView}
    />
  );
}

export default Container;
